/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultScheduledBroadcastResponse } from '../../models/api-response-paged-result-scheduled-broadcast-response';
import { PagedRequestScheduledBroadcast } from '../../models/paged-request-scheduled-broadcast';

export interface SearchScheduledBroadcast$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestScheduledBroadcast
}

export function searchScheduledBroadcast(http: HttpClient, rootUrl: string, params: SearchScheduledBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultScheduledBroadcastResponse>> {
  const rb = new RequestBuilder(rootUrl, searchScheduledBroadcast.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultScheduledBroadcastResponse>;
    })
  );
}

searchScheduledBroadcast.PATH = '/v1/api/ui/broadcast/search-scheduled';
